import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useThemeMode } from '../context/ThemeContext';
import { useLanguage } from '../i18n';

const Footer: React.FC = () => {
  const { mode } = useThemeMode();
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'divider',
        background: mode === 'dark'
          ? 'linear-gradient(90deg, rgba(139, 92, 246, 0.05) 0%, rgba(59, 130, 246, 0.05) 100%)'
          : 'linear-gradient(90deg, rgba(139, 92, 246, 0.03) 0%, rgba(59, 130, 246, 0.03) 100%)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {/* Left - Company Info */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: 1.5,
              background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FF6B6B 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(255, 215, 0, 0.3)',
            }}
          >
            <Typography sx={{ color: '#1a1a2e', fontWeight: 900, fontSize: '0.65rem' }}>
              KR
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            © {currentYear}{' '}
            <Link
              href="https://krelixir.com/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#8B5CF6',
                textDecoration: 'none',
                fontWeight: 600,
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              KR Elixir
            </Link>
            . {t.appFooter.allRightsReserved}.
          </Typography>
        </Box>

        {/* Center - Tagline */}
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
            display: { xs: 'none', md: 'block' },
          }}
        >
          {t.appFooter.tagline}
        </Typography>

        {/* Right - Links */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Link
            href="https://krelixir.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.8125rem',
              '&:hover': {
                color: '#8B5CF6',
              },
            }}
          >
            {t.appFooter.website}
          </Link>
          <Link
            href="https://krelixir.com/cloud-solutions/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.8125rem',
              '&:hover': {
                color: '#8B5CF6',
              },
            }}
          >
            {t.appFooter.cloudSolutions}
          </Link>
          <Link
            href="https://krelixir.com/data-solutions/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.8125rem',
              '&:hover': {
                color: '#8B5CF6',
              },
            }}
          >
            {t.appFooter.dataSolutions}
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
